import React from 'react'
import {
  CBadge,
  CCard,
  CCardBody,
  CForm,
  CFormInput,
  CLoadingButton,
  CSpinner,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilStar } from '@coreui/icons'
import { useFormik } from 'formik'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import { InfoBox } from 'src/components/common/ImportWizard'

const Potm = ({ data, loading, loadingPotm, setLoadingPotm }) => {
  const formik = useFormik({
    initialValues: {
      data,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      setLoadingPotm(true)
      CommonService.updateBonusPoint({ data: values.data, type: 'potm' })
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch(() => {
          ToastComponent('Something went wrong. Please try again.', 'error')
        })
        .finally(() => setLoadingPotm(false))
    },
  })

  return (
    <CCard className="bp-panel">
      <CCardBody>
        <div className="bp-panel-toolbar">
          <div>
            <h2 className="bp-panel-title">
              <CIcon icon={cilStar} className="me-2 text-warning" />
              Player of the Match Bonus
            </h2>
            <p className="bp-panel-note">
              Extra fantasy points awarded to a team&apos;s Player of the Match.
            </p>
          </div>
        </div>

        <InfoBox color="info">
          Applies once a fixture&apos;s Player of the Match is set. Leave a team&apos;s value
          unchanged to keep its current bonus.
        </InfoBox>

        {loading ? (
          <div className="d-flex align-items-center gap-2 text-medium-emphasis py-4">
            <CSpinner size="sm" />
            <span>Loading teams...</span>
          </div>
        ) : (
          <CForm onSubmit={formik.handleSubmit}>
            <div className="bp-table-wrap">
              <table className="bp-table">
                <thead>
                  <tr>
                    <th>Team</th>
                    <th className="bp-table-col-input text-end">Bonus Points</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={2} className="text-center text-medium-emphasis py-4">
                        No teams yet - add a team before setting bonus points.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={item.id}>
                        <td className="bp-team-name">{item.name}</td>
                        <td className="text-end">
                          <CFormInput
                            id={`potm_bonus_${item.id}`}
                            className="bp-input ms-auto"
                            type="number"
                            step="any"
                            inputMode="decimal"
                            value={formik.values.data[index]?.potm_bonus ?? ''}
                            onChange={(e) =>
                              formik.setFieldValue(`data.${index}.potm_bonus`, e.target.value)
                            }
                            onFocus={(e) => e.target.select()}
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {data.length > 0 && (
              <div className="bp-form-actions">
                <CLoadingButton type="submit" color="primary" loading={loadingPotm}>
                  Save
                </CLoadingButton>
                {formik.dirty && (
                  <CBadge color="warning" shape="rounded-pill" className="px-3 py-2">
                    Unsaved changes
                  </CBadge>
                )}
              </div>
            )}
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default Potm
